import axios from "axios";

export default {
  namespaced: true,
  state: {
    loaded: false,
    showOptions: false,
    accountList: [],
    userList: [],
    onBehalfAccount: {
      id: auth.usergroup,
      name: auth.company
    },
  },
  mutations: {
    setOnBehalfAccount (state, account) {
      state.onBehalfAccount = account;
    },
    setLoaded (state, loaded) {
      state.loaded = loaded;
    },
    setToggleOptions: function (state, e) {
      state.showOptions = !state.showOptions;
    },
    setShowOptions: function (state, e) {
      state.showOptions = false;
    },
    setAccountList: function (state, accountList) {
      state.accountList = accountList;
    },
    setUserList: function (state, users) {
      state.userList = users;
    }
  },
  actions: {
    async loadAccountData ({commit}, accDataUrl) {
      return axios.get(accDataUrl).then(res => {
          commit('setAccountList', res.data);
          commit('setLoaded', true);
        }
      );
    },
    async loadUsersForAccount ({commit}, account) {
      return axios.get(`/account/${account.id}/users`).then(res => {
          commit('setUserList', res.data.data);
        }
      );
    },
  }
};
